import { Controller } from "@hotwired/stimulus"
import RequestHelper from "../helpers/request_helper"

export default class extends Controller {
  static get targets() { return ["rows", "addButton", "noSeatsMessage", "submitButton", "form", "input"]; }
  static get values() { return { availableSeats: Number }; }

  // An organization on an unlimited-users plan renders no seat count at all, and every
  // comparison against NaN is false - which is what keeps the add button from ever disabling.
  get availableSeats() {
    return this.hasAvailableSeatsValue ? this.availableSeatsValue : NaN;
  }

  fields() { return this.rowsTarget.querySelectorAll(".fields"); }

  fieldsLimitReached() { return this.fields().length >= this.availableSeats; }

  add(event) {
    event.preventDefault();

    if (this.fieldsLimitReached()) { return; }

    const clone = this.fields()[0].cloneNode(true);
    clone.querySelectorAll("input").forEach(input => { input.value = ""; });
    clone.querySelectorAll("select").forEach(select => { select.selectedIndex = 0; });
    this.rowsTarget.appendChild(clone);

    if (this.fieldsLimitReached()) {
      this.addButtonTarget.classList.add("btn-disabled");
      this.noSeatsMessageTarget.classList.remove("hidden");
    }
  }

  remove(event) {
    const fields = this.fields();
    const target = event.target.closest(".fields");

    if (fields.length === 1) {
      target.querySelectorAll("input").forEach(input => { input.value = ""; });
      target.querySelectorAll("select").forEach(select => { select.selectedIndex = 0; });
      this.updateSubmitButtonStatus();
    } else {
      target.remove();

      if (!this.fieldsLimitReached()) {
        this.addButtonTarget.classList.remove("btn-disabled");
        this.noSeatsMessageTarget.classList.add("hidden");
      }
    }
  }

  updateSubmitButtonStatus() {
    for (const input of this.inputTargets) {
      if (input.value.trim().length > 0) {
        this.submitButtonTarget.disabled = false;
        return;
      }
    }

    this.submitButtonTarget.disabled = true;
  }

  submit(event) {
    event.preventDefault();

    const invitations = Array.from(this.fields()).map(field => ({
      email: field.querySelector("input").value,
      role: field.querySelector("select").value
    }));

    const options = RequestHelper.defaultPostOptions();
    options.headers = Object.assign({}, options.headers, { "Content-Type": "application/json" });
    options.body = JSON.stringify({ invitations });

    fetch(this.formTarget.action, options).
      then(response => response.json().then(data => ({ ok: response.ok, data }))).
      then(({ ok, data }) => {
        if (ok) {
          // S3: our own controller's JSON response, same origin as this page - asserted before
          // navigating per the S3 rule rather than trusting `data.redirect_url` outright. The
          // failing branch does not navigate; it routes into the same toast the server-rejection
          // branch below already uses.
          if (RequestHelper.isSameOriginUrl(data.redirect_url)) {
            window.location.href = data.redirect_url;
          } else {
            window.ltAlert({ message: "An error occurred while completing this action.", type: "toast-error" });
          }
        } else {
          window.ltAlert({ message: data.message, type: "toast-error" });
        }
      }).
      catch(this.logFailedCall);
  }

  logFailedCall(response) { console.warn(response); }
}
